"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CfgCssClassListEn = /** @class */ (function () {
    function CfgCssClassListEn() {
    }
    CfgCssClassListEn.getLangData = function () {
        return {
            document_title: "Styles",
            editor: {
                breadcrumb: {
                    new_css_class: ["Create CSS class"],
                    edit_css_class: ["Edit CSS class"]
                },
                message: {
                    css_class_added: "Css class was added!",
                    css_class_changed: "Css class was changed!"
                },
                error: {
                    field_class_name_empty: "Field [CSS class name] is empty!",
                    field_class_type_empty: "Field [CSS class type] is empty!",
                },
                title: {
                    new_css_class: "Add CSS class",
                    edit_css_class: "Edit CSS class",
                },
                fields: {
                    class_name: {
                        caption: "Class name:",
                        placeholder: "Enter CSS class name",
                    },
                    class_type: {
                        caption: "Class type:",
                        placeholder: "Enter CSS class type",
                    }
                },
                checkboxes: {
                    deprecated: "Css class is deprecated"
                },
                buttons: {
                    save: "Save",
                    create: "Create",
                    back: "Back",
                }
            }, list: {
                message: {
                    set_as_actual_fmt: "Css class {0} marked as actual",
                    set_as_deprecated_fmt: "Css class {0} marked as deprecated",
                    css_class_deleted_fmt: "Css class {0} deleted succesfully",
                    css_class_loaded: "Css class loaded succesfully"
                },
                rows: {
                    class_name: "Class name",
                    class_type: "Class type",
                    is_actual: {
                        title: "Actual",
                        menu: {
                            actual: {
                                menu: "Set as actual",
                                text: "Yes"
                            },
                            deprecate: {
                                menu: "Set as deprecated",
                                text: "No"
                            }
                        },
                        filter: {
                            actual: "Actual",
                            deprecate: "Deprecated",
                        }
                    },
                    date_added: "Added",
                    date_changed: "Changed",
                    action: {
                        title: "Actions",
                        edit: "Edit",
                        delete: {
                            hint: "Delete",
                            confirm: "Delete this record ?",
                        }
                    }
                },
                toolbars: {
                    hints: {
                        create: "Create",
                        refresh: "Update",
                    }
                },
                footer: {
                    title_fmt: "Shown on page : {0} records",
                },
                details: {
                    created: "Created:",
                    changed: "Changed:",
                }
            }
        };
    };
    return CfgCssClassListEn;
}());
exports.CfgCssClassListEn = CfgCssClassListEn;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_css_class/ui/lang/CfgCssClassListEn.ts
// module id = 2361
// module chunks = 0